import React from "react";
import PropTypes from "prop-types";
import { H3 } from "components/core/Typography";
import "./DropdownItem.scss";

export default function DropdownItem({ icon, label, children }) {
  return (
    <div className="slp-dropdown-item">
      <div className="slp-dropdown-item__content">
        <div className="slp-dropdown-item__icon">{icon}</div>
        <H3 className="slp-dropdown-item__label" size="small" weight="bold" last>{label}</H3>
      </div>
      {children && (
        <div className="slp-dropdown-item__panel">
          {children}
        </div>
      )}
    </div>
  );
}

DropdownItem.propTypes = {
  icon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  children: PropTypes.node
};
